import SettingsPaymentsApi from "@/api/v2/settings-payments";

// initial state
const state = () => ({
    loaded: false,
    loading: false,
    balance: 0.0,
    balanceDue: 0.0,
    pendingPaymentsAmount: 0.0,
    pendingPaymentsCount: 0,
    pendingBalanceAmount: 0.0,
    earnedAmounts: {},
    contractorEscrowAmount: 0.0,
    clientEscrowAmount: 0.0,
});

// getters
const getters = {
    isLoaded: (state) => state.loaded,
    isLoading: (state) => state.loading,
    getBalance: (state) => state.balance,
    getBalanceDue: (state) => state.balanceDue,
    hasBalanceDue: (state) => state.balanceDue > 0 || state.balanceDue < 0,
    getPendingPaymentsAmount: (state) => state.pendingPaymentsAmount,
    getPendingPaymentsCount: (state) => state.pendingPaymentsCount,
    getPendingBalanceAmount: (state) => state.pendingBalanceAmount,
    getEarnedAmounts: (state) => state.earnedAmounts,
    getContractorEscrowAmount: (state) => state.contractorEscrowAmount,
    getClientEscrowAmount: (state) => state.clientEscrowAmount,
};

// actions
const actions = {
    load ({state, dispatch}) {
        if (state.loaded) {
            return;
        }

        return dispatch('reload');
    },
    reload ({state}) {
        if (state.loading) {
            return;
        }

        state.loading = true;

        const api = new SettingsPaymentsApi();

        api.getBalance().then(response => {
            state.loaded = true;
            state.loading = false;
            state.balance = response.data.balance;
            state.balanceDue = response.data.balanceDue;
            state.pendingPaymentsAmount = response.data.pendingPaymentsAmount;
            state.pendingPaymentsCount = response.data.pendingPaymentsCount;
            state.pendingBalanceAmount = response.data.pendingBalanceAmount;
            state.earnedAmounts = response.data.earned;
            state.contractorEscrowAmount = response.data.contractor_escrow;
            state.clientEscrowAmount = response.data.client_escrow;
        });
    },
};

// mutations
const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
